export default "__VITE_ASSET__0388f66b__"